module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAApBAMAAACxeabGAAAALVBMVEVHcEz////////////////////////////////////////////////////////NXt0CAAAADnRSTlMAlizvwb1eC5091ISwIl2ND2AAAAC+SURBVCjP1dK/CYIxEIfhH/gPFALa2jiCE4gDOINYWVg5gYgDuIE2LuIo4eMTsfBm8GIukuRuAa9K3jyEFAGK6Z9gDNFSR0fU6tohEy8M3FjY0czARAbmBxiYo+BjSQX7gvYE+5x6rCOe5xQQXFJEXFHBNRVc0WyRU5c/6+/p0KTOolxfmvLurSnXp6a89ZpKrajUinJ93MKn4bMRxWnTR/rSqyzpnmq45pyqR/dHcUh1A+xW0+1lH+pgHGeCD6sF9fJsonMDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/pen.png
// module id = nYcX
// module chunks = 1